"use client";

import { c as _c } from "react/compiler-runtime";
import GridRow from "@/components/common/grid-row/grid-row";
import css from "./product-hero.module.scss";
import GridColumn from "@/components/common/grid-column/grid-column";
import Link, { LinkType, LinkStyle } from "@/components/common/link/link";
import SuperTitle from "@/components/common/supertitle/supertitle";
import { ProductHero as ProductHeroType } from "@/sanity/sanity.types";
import imageUrl from "@/sanity/utilities/imageUrl";
import Image from "@/components/common/image/image";
import CheckmarkIcon from "@/components/common/checkmark-icon/checkmark-icon";
import ArrowIcon from "@/components/common/arrow-icon/arrow-icon";
import { ImageLoading } from "@/utilities/imageLoading";
interface IProductHeroProps {
  data: ProductHeroType;
}
const ProductHero = props => {
  const $ = _c(21);
  const {
    data
  } = props;
  const {
    bullets,
    cta,
    eyebrow,
    headline,
    image,
    ctas
  } = data;
  let t0;
  if ($[0] !== eyebrow) {
    t0 = <SuperTitle className={css.productHeroSuperTitle}>{eyebrow}</SuperTitle>;
    $[0] = eyebrow;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== headline) {
    t1 = <h1 className={`${css.productHeroTitle} product-title`}>{headline}</h1>;
    $[2] = headline;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== bullets) {
    t2 = bullets && <ul className={css.productHeroPoints}>{bullets.map(_temp)}</ul>;
    $[4] = bullets;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== cta) {
    t3 = cta?.link && <Link className="mb-3 mt-6 !w-full lg:mb-0 lg:mt-12 lg:!w-max" linkType={LinkType.BUTTON} href={cta.link.href ?? ""} data-cta-id={cta.link.ctaId ?? ""} data-cta-value={cta.link.ctaValue ?? ""}>{cta.link.label}</Link>;
    $[6] = cta;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== ctas) {
    t4 = Array.isArray(ctas) && ctas.length > 0 && <div className="flex w-full flex-col justify-center"><div className="flex flex-wrap justify-between gap-6 py-6 md:mr-6">{ctas.map(_temp2)}</div></div>;
    $[8] = ctas;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <GridColumn lg={6} className={css.productHeroText}>{t0}{t1}{t2}{t3}{t4}</GridColumn>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== image) {
    t6 = image?.asset && <GridColumn lg={6} className={`${css.productHeroImage} aspect-[590/596] w-full lg:max-w-[500px]`}><Image src={imageUrl(image.asset).width(500).url()} className="max:w-[500px] h-auto" alt="Product Image" width={1164} height={1176} fetchPriority="high" loading={ImageLoading.EAGER} /></GridColumn>;
    $[16] = image;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className={css.productHero}><GridRow className={css.productHeroContent}>{t5}{t6}</GridRow></div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default ProductHero;
function _temp(bullet, index) {
  return <li key={index} className="speakable__summary flex max-md:items-start md:items-center"><CheckmarkIcon className="mr-3 flex-shrink-0 max-md:mt-[2px] max-md:h-5 max-md:w-5" loading={ImageLoading.EAGER} /><span>{bullet}</span></li>;
}
function _temp2(cta_0, index_0) {
  const isLink = cta_0.style === "link";
  const isSecondary = cta_0.style === "secondary";
  return <div key={index_0} className={`w-full ${index_0 < 2 ? "md:w-[calc(49%-0.5rem)]" : "md:w-full"} `}>{cta_0.link?.href && <Link className={`${index_0 === 2 ? "" : "!w-full"}`} linkType={isLink ? LinkType.DEFAULT : LinkType.BUTTON} linkStyle={isSecondary ? LinkStyle.SECONDARY : LinkStyle.PRIMARY} href={cta_0.link.href} data-cta-id={cta_0.link.ctaId ?? ""} data-cta-value={cta_0.link.ctaValue ?? ""}><span className="inline-flex gap-2 text-start">{cta_0.link.label}{isLink && <ArrowIcon className="mt-1" />}</span></Link>}</div>;
}